module.exports = __webpack_public_path__ + "img/avatar-rey.921784ac.png";